// extracted by mini-css-extract-plugin
export default {"container":"cE-z","dimension":"dE-z","dimensionLabels":"eE-z"};